import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { useHistory } from 'react-router-dom';
import { ROOT_PATH } from '../constants/RouteConstants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NotFoundPage = () => {
  const history = useHistory();
  return /*#__PURE__*/_jsxs(UIErrorMessage, {
    type: "notFound",
    "data-test-id": "404-page",
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.pageNotFound.subTitle"
      })
    }), /*#__PURE__*/_jsx(UILink, {
      onClick: () => history.push(ROOT_PATH),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.pageNotFound.linkToArticlesPage"
      })
    })]
  });
};
export default NotFoundPage;